__turbopack_context__.v({
  "bruketIWiaredApp": "QokVKa_bruketIWiaredApp",
  "brutaleApp": "QokVKa_brutaleApp",
  "butchersMarketApp": "QokVKa_butchersMarketApp",
  "cornerApp": "QokVKa_cornerApp",
  "heatApp": "QokVKa_heatApp",
  "kafeMagasinetApp": "QokVKa_kafeMagasinetApp",
  "klappenBagerietApp": "QokVKa_klappenBagerietApp",
  "klappenHalsterApp": "QokVKa_klappenHalsterApp",
  "klappenToppstuganApp": "QokVKa_klappenToppstuganApp",
  "lundsKommunApp": "QokVKa_lundsKommunApp",
  "morenoPizzaApp": "QokVKa_morenoPizzaApp",
  "navBrand": "QokVKa_navBrand",
  "nordrestAxisApp": "QokVKa_nordrestAxisApp",
  "olandschokladApp": "QokVKa_olandschokladApp",
  "strandgatanApp": "QokVKa_strandgatanApp",
  "tacosAndTequilaApp": "QokVKa_tacosAndTequilaApp",
  "whiteLabeled": "QokVKa_whiteLabeled",
});
